<div class="toolbar">
  <div class="logo-toolbar">
    <img src="assets/images/logo-fiserv.png" alt="cargando imagen" />
  </div>
</div>
